import { defaultSystemRoles } from '@juvare/contact-management/backend/features/permissions'; // TODO: Change to shared folder after PFCM-1393
/**
 * Type-safe access to system roles
 *
 * * May contain dynamic non-predefined role names
 * * May return undefined
 */
export function getSystemRoleByName(systemRole) {
    return defaultSystemRoles[systemRole];
}
